import { DEFAULT_LATEST, DEFAULT_EARLIEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import { LegalAssociationsEventItemModel } from '../../eventItem/types';

const legalAssociationsInternationalAndDomesticTerrorismAssociationItemValidator: ValidateJSModel<LegalAssociationsEventItemModel> = {
  Why: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { presence: true, hasValue: true };
  },
  When: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST), latest: DEFAULT_LATEST },
  }),
  WhyStill: (value, attributes, attributeName, options) => {
    if (attributes?.When?.present === true) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  WhyStop: (value, attributes, attributeName, options) => {
    if (attributes?.When?.present === false) {
      return { presence: true, hasValue: true };
    }

    return {};
  },
  What: { presence: true, hasValue: true },
};

export default legalAssociationsInternationalAndDomesticTerrorismAssociationItemValidator;
